module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_kamakura-4eb41327b79d3e0332e087777bced4e1.jpg";